import { render } from "./StepB.vue?vue&type=template&id=1a25a8d3"
import script from "./StepB.vue?vue&type=script&lang=js"
export * from "./StepB.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/signupLawyer/StepB.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a25a8d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a25a8d3', __exports__)) {
    api.reload('1a25a8d3', __exports__)
  }
  
  module.hot.accept("./StepB.vue?vue&type=template&id=1a25a8d3", () => {
    api.rerender('1a25a8d3', render)
  })

}


export default __exports__